<template>
    <div class="visualizar-pdf-wrapper">
        <div v-if="pdfUrl" class="pdf-viewer-container">
            <div class="pdf-file-name" :title="nomeArquivoPreviewDeclaracaoVinculo">
                {{ nomeArquivoPreviewDeclaracaoVinculo }}
            </div>
            <iframe
                :src="srcVisualizacaoPdfDeclaracaoVinculo"
                width="100%"
                height="800px"
                frameborder="0"
            ></iframe>
        </div>

        <div v-if="carregando" class="loading-overlay">
            <div class="spinner-container">
                <i class="fa fa-spinner fa-spin fa-3x text-primary"></i>
                <p class="mt-3 text-primary font-weight-bold">Gerando PDF...</p>
            </div>
        </div>

        <div class="mt-3 mb-3 d-flex justify-content-start align-items-center no-print">
            <b-button variant="warning" class="mr-2" @click="$emit('voltar')">
                <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.75 8.75L0.75 4.75M0.75 4.75L4.75 0.75M0.75 4.75H8.75C9.81087 4.75 10.8283 5.17143 11.5784 5.92157C12.3286 6.67172 12.75 7.68913 12.75 8.75C12.75 9.81087 12.3286 10.8283 11.5784 11.5784C10.8283 12.3286 9.81087 12.75 8.75 12.75H6.75" stroke="#2D3439" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Voltar
            </b-button>

            <b-button class="btn-blue-custom mr-2" @click="baixarPdf" :disabled="!pdfBlob">
                <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13 9V11.6667C13 12.0203 12.8595 12.3594 12.6095 12.6095C12.3594 12.8595 12.0203 13 11.6667 13H2.33333C1.97971 13 1.64057 12.8595 1.39052 12.6095C1.14048 12.3594 1 12.0203 1 11.6667V9M3.66667 5.66667L7 9M7 9L10.3333 5.66667M7 9V1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Baixar PDF
            </b-button>

            <b-button class="btn-green-custom" :disabled="carregando || !pdfBlob" @click="$emit('proximo')">
                <i class="fa fa-check mr-1"></i> Próxima Etapa
            </b-button>
        </div>
    </div>
</template>

<script>
import BoletimMedicaoServicos from '../../../BoletimMedicaoServicos.js';

export default {
    name: 'DeclaracaoVinculoVisualizarPDF',
    props: {
        dadosHeader: {
            type: Object,
            required: true
        },
        boletimMedicaoId: {
            type: [String, Number],
            required: true
        },
        cnpjContratada: {
            type: String,
            default: ''
        },
        itens: {
            type: Array,
            default: () => []
        },
        editavel: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            carregando: false,
            pdfUrl: null,
            pdfBlob: null
        }
    },
    computed: {
        srcVisualizacaoPdfDeclaracaoVinculo() {
            if (!this.pdfUrl) return null;
            const [urlSemFragmento] = this.pdfUrl.split('#');
            return `${urlSemFragmento}#toolbar=0`;
        },
        nomeArquivoPreviewDeclaracaoVinculo() {
            return this.montarNomeArquivoDeclaracaoVinculo();
        },
    },
    methods: {
        async gerarRelatorio() {
            this.carregando = true;
            try {
                const dados = {
                    cnpj: this.cnpjContratada,
                    boletimMedicaoId: this.boletimMedicaoId,
                    numeroContrato: this.dadosHeader.numeroContrato || '',
                    contratada: this.dadosHeader.contratada || '',
                    objeto: this.dadosHeader.objeto || '',
                    periodo: this.dadosHeader.periodo || '',
                    numeroBoletim: this.dadosHeader.medicao ? String(this.dadosHeader.medicao) : '',
                    logoSuape: 'data:image/png;base64,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',
                    logoFornecedorUrl: this.dadosHeader.logoFornecedorUrl
                };

                const response = await BoletimMedicaoServicos.obterDeclaracaoVinculoRelatorio(dados);

                if (response) {
                    this.pdfBlob = new Blob([response], { type: 'application/pdf' });

                    if (this.pdfUrl) {
                        URL.revokeObjectURL(this.pdfUrl);
                    }

                    this.pdfUrl = URL.createObjectURL(this.pdfBlob);
                }
            } catch (error) {
                console.error('Erro ao gerar relatório:', error);
                this.$toast.error('Não foi possível gerar o relatório. Por favor, tente novamente.');
            } finally {
                this.carregando = false;
            }
        },
        normalizarParteNomeArquivo(valor, fallback = '') {
            const texto = (valor || '').toString().trim();
            if (!texto) return fallback;

            const semAcento = texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            const limpo = semAcento
                .replace(/[\\/:*?"<>|]+/g, '_')
                .replace(/\s+/g, '_')
                .replace(/_+/g, '_')
                .replace(/^[_\.]+|[_\.]+$/g, '');

            return limpo || fallback;
        },
        montarNomeArquivoDeclaracaoVinculo() {
            const nomeBm = this.normalizarParteNomeArquivo(
                this.dadosHeader?.medicao || this.boletimMedicaoId,
                'BM'
            );
            const numeroContrato = this.normalizarParteNomeArquivo(
                this.dadosHeader?.numeroContrato,
                'Contrato'
            );

            return `DeclaracaoVinculo_${nomeBm}_${numeroContrato}.pdf`;
        },
        baixarPdf() {
            if (!this.pdfBlob) return;
            this.$download(this.pdfBlob, this.montarNomeArquivoDeclaracaoVinculo());
        }
    },
    mounted() {
        this.gerarRelatorio();
    },
    beforeDestroy() {
        if (this.pdfUrl) {
            URL.revokeObjectURL(this.pdfUrl);
        }
    }
};
</script>

<style scoped>
.visualizar-pdf-wrapper {
    background-color: #f4f4f4;
    padding: 20px;
    min-height: 100vh;
}

/* STEPS (Layout RelatorioParaExportacao.vue) */
.steps-container { margin-bottom: 20px; }
.step-item { display: flex; align-items: center; font-weight: 600; color: #007bff; font-size: 0.9rem; }
.step-item.text-muted { color: #6c757d; }
.step-dot { width: 12px; height: 12px; background-color: #007bff; border-radius: 50%; margin-right: 8px; }
.step-dot.gray { background-color: #dee2e6; }
.step-line { width: 60px; height: 2px; background-color: #007bff; margin: 0 15px; }

/* BOTOES (Estilo CronogramaAcoes.vue) */
.btn-blue-custom {
    background-color: #2E60AD !important;
    border-color: #2E60AD !important;
    color: #fff !important;
}
.btn-blue-custom:hover {
    filter: brightness(0.9);
}

.btn-green-custom {
    background-color: #23A26D !important;
    border-color: #23A26D !important;
    color: #fff !important;
}
.btn-green-custom:hover {
    filter: brightness(0.9);
}

.preview-container {
    width: 100%;
    position: relative;
    min-height: 200px;
    background-color: #fff;
    padding: 10px;
    border-radius: 4px;
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
}

.preview-container.has-pdf {
    min-height: 800px;
}

.pdf-viewer-container {
    width: 100%;
    height: 100%;
}

.pdf-file-name {
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #2d3439;
    word-break: break-all;
}

.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
}

.spinner-container {
    text-align: center;
}

@media print {
    .no-print {
        display: none !important;
    }
}
</style>
